import {
  RecorderControl,
  RecorderState,
  Thumbnail,
} from '@vimily/bonjoro-ui-components-v2/VideoRecorder';
import { DateTime } from 'luxon';
import React, { RefObject } from 'react';
import { GreetSendType, MessageTemplate } from '~/types/models';
import { RecorderDrawerProps } from '.';

export interface RecorderDrawerContext
  extends Pick<
    RecorderDrawerProps,
    | 'profiles'
    | 'ctaText'
    | 'disableCta'
    | 'defaultSubjectLine'
    | 'defaultMessage'
    | 'demoTemplateAsDefault'
    | 'fixedTemplateDropdown'
    | 'hideScheduler'
    | 'topSidebarComponent'
    | 'emailPreviewDisclaimerContent'
    | 'emailPreviewBannerContent'
    | 'onRecordingStart'
    | 'onRecordingStop'
    | 'onRecordingRedo'
    | 'onRecordingComplete'
    | 'onRecorderPlay'
    | 'onRecorderSettingsClick'
    | 'onRecorderSettingsCloseClick'
    | 'onScheduleRemove'
    | 'onScheduleLater'
    | 'onChangeScheduleClick'
    | 'onFileUpload'
    | 'onThumbnailSelect'
    | 'onMessageTemplateSelect'
    | 'onMessageTemplateSelectionClick'
    | 'onThumbnailSelectionClick'
  > {
  hasValidVideo: boolean;

  messageTemplate?: MessageTemplate;
  setMessageTemplate: (template?: MessageTemplate) => void;

  selectedThumbnailIndex?: number;
  setSelectedThumbnailIndex: (index?: number) => void;

  message?: string;
  setMessage: (message?: string) => void;

  videoUrl: string;
  setVideoUrl: (videoUrl: string) => void;

  generatedThumbnails?: Thumbnail[];
  setGeneratedThumbnails: (thumbnails?: Thumbnail[]) => void;

  recorderControl: RefObject<RecorderControl>;
  recorderState: RecorderState;
  setRecorderState: (recorderState: RecorderState) => void;

  videoBlob?: Blob;
  setVideoBlob: (videoBlob?: Blob) => void;

  infoModalOpen: boolean;
  setInfoModalOpen: (open: boolean) => void;

  schedulerModalOpen: boolean;
  setSchedulerModalOpen: (open: boolean) => void;

  isExternalVideo: boolean;
  setIsExternalVideo: (value: boolean) => void;

  sendType: GreetSendType;
  setSendType: (sendType: GreetSendType) => void;

  sendAt?: DateTime;
  setSendAt: (sendAt?: DateTime) => void;

  uploadProgress: number;
  isUploading: boolean;

  interpolatedThumbnails?: Thumbnail[];
  selectedThumbnail?: Thumbnail;

  onSubmit: () => Promise<void>;

  closeDrawer: () => void;
}

export default React.createContext<RecorderDrawerContext>(
  {} as unknown as RecorderDrawerContext
);
